const _ = require('underscore')

// setup underscore
_.templateSettings.escape = /\{\{(.+?)\}\}/g // {{ escaped_value }}
_.templateSettings.interpolate = /\[\[(.+?)\]\]/g // [[ raw_value ]]
_.templateSettings.evaluate = /<:([\s\S]+?):>/g // <: javascript logic :>
_.templateSettings.variable = 'data'

const enhancedUnderscore = _.mixin({
    deepClone: function deepClone(obj) {
        try {
            return JSON.parse(JSON.stringify(obj))
        } catch {
            throw new Error('This object cannot be deep cloned.')
        }
    },
    isDefined: function isDefined() {
        return ! _.isUndefined.apply(this, arguments)
    },
})

module.exports = enhancedUnderscore
